import { useEffect, useRef, useState } from 'react';
import { TextArea } from '../components/formFields/textArea/TextArea.component';
import { appStyles, logoImage } from './app.style'
import { api } from '../data/api';
import { Spinner } from '../components/spinner/Spinner.component';
import { useNavigate } from 'react-router-dom';
import { ButtonInApp } from './ButtonInApp.component';



export const AyudaApp = () => {
	const navigate = useNavigate();
	const [pregunta, setPregunta] = useState('');
	const preguntaRef = useRef<HTMLTextAreaElement>(null);
	const [loading, setLoading] = useState(false);
	const [emailSent, setEmailSent] = useState(false);

	const handleSubmit = async () => {
		console.log("### handleSubmit", pregunta);

		if (emailSent) {
			navigate('/app/menu')
		} else {
			setLoading(true);
			try {
				await api.post('/api/ayuda/paciente', {
					mensaje: pregunta
				});
				setEmailSent(true);
			} catch (error) {
				console.error("### error", error);
			} finally {
				setLoading(false);
			}
		}
	}

	useEffect(() => {
		if (preguntaRef.current) {
			preguntaRef.current.focus();
		}
	}, []);

	if (loading) return <Spinner />

	return (
		<div style={appStyles.container}>
			<div style={appStyles.logoContainer}>
				<img src={logoImage} alt="logo" style={appStyles.logo} />
				<div>
					<h3>Kaiteki</h3>
					<h1 style={appStyles.title}>Ayuda</h1>
				</div>
			</div>
			<div style={appStyles.formContainer}>
				<form onSubmit={handleSubmit}>
					{emailSent ?
						<p>Gracias por tu mensaje. Nos pondremos en contacto contigo lo antes posible. Recibiras un correo de parte nuestra. Revisa la carpeta de Spam si no lo encuentras.</p>
					:
						<>
							<p>Escribe tu pregunta y nos pondremos en contacto contigo lo antes posible.</p>
							<TextArea
								ref={preguntaRef}
								label="Pregunta"
								value={pregunta}
								onChange={(value) => setPregunta(value)} 
								rows={6}
								children={undefined}					
							/>
						</>
					}
					<div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '20px' }}>
						<ButtonInApp 
							label={emailSent ? 'Volver' : 'Enviar'}
							onClick={handleSubmit}
							disabled={pregunta.length === 0}
						/>
					</div>
				</form>
			</div>
		</div>
	)
	
}